import React, { useEffect } from 'react';
import './Pagination.css';
import { TPagination } from '../../types/shared/Pagination';
import { useWidthContext } from '../../providers/Width';
import { Col, Row, Section } from '../../importCL';
import { ButtonWrapper } from '../LinkWrapper/LinkWrapper';

type TPaginationPage = {
    page: number;
    url: string;
};

const MAX_PAGES = 5;
const MAX_PAGES_MOBILE = 3;

const Pagination = (props: TPagination): JSX.Element => {

    if (props.lastPageNumber < 1) {
        return <></>;
    }

    const pageList: TPaginationPage[] = [];
    const { width } = useWidthContext();
    const pagesToDisplay = width <= 768 ? MAX_PAGES_MOBILE : MAX_PAGES;

    const generatePages = () => {
        let start = 1;
        let end = props.lastPageNumber;
        if (props.lastPageNumber > pagesToDisplay) {
            const midPoint = Math.floor(pagesToDisplay / 2);
            start = props.pageNumber - midPoint;
            end = props.pageNumber + midPoint;
            if (start < 1) {
                start = 1;
                end = pagesToDisplay;
            }
            if (end > props.lastPageNumber) {
                end = props.lastPageNumber;
                start = props.lastPageNumber - pagesToDisplay + 1;
            }
        }
        for (let i = start ; i <= end ; i++) {
            pageList.push({page: i, url:buildUrl(props.baseUrl,i)});
        }
    }
    const buildUrl = (url: string, pageNum: number): string => {
        if (props.buildPageUrl) return props.buildPageUrl(pageNum);
        return props.newsFeedFilter ? `${url}.${pageNum}?NewsID=${props.newsFeedFilter}` : `${url}.${pageNum}`;
    }

    generatePages();

    return (
        <Section className='Pagination'>
            <Row className='Pagination__Row'>
                <Col className='Pagination__previous'>
                    <ButtonWrapper                        
                        href={props.pageNumber > 1 ? buildUrl(props.baseUrl,props.pageNumber-1) : null}
                        size='medium'
                        disabled={props.pageNumber <= 1}
                    >
                        {'<'}
                    </ButtonWrapper>
                </Col>
                {pageList.map((page) => {
                    return <Col key={page.page} className='Pagination__page'>
                        <ButtonWrapper
                            href={page.url}
                            size='medium'
                            className={page.page === props.pageNumber ? 'active' : ''}
                        >
                            {page.page}
                        </ButtonWrapper>
                    </Col>
                })}
                <Col className='Pagination__next'>
                    <ButtonWrapper
                        href={props.pageNumber < props.lastPageNumber ? buildUrl(props.baseUrl,props.pageNumber+1) : null}
                        size='medium'
                        disabled={props.pageNumber >= props.lastPageNumber}
                    >
                        {'>'}
                    </ButtonWrapper>
                </Col>
            </Row>
        </Section>
    )
};

export default Pagination;
